import axios from 'axios';
import { REST_HOSTNAME } from '../Config';
import { ChineseTeacher } from './UserApi';

const axiosInstance = axios.create({
    baseURL: REST_HOSTNAME
});

axiosInstance.interceptors.request.use(
    function (config) {
        const jwt = localStorage.getItem('jwt');
        if (jwt) {
            config.headers['x-access-token'] = jwt;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export const SpeakerRoles = {
    maleTeacher: 'male_teacher',
    femaleTeacher: 'female_teacher',
    femaleTeacher2: 'female_teacher_2',
    speakerA: 'speaker_a',
    speakerB: 'speaker_b',
} as const;

export type SpeakerRole = typeof SpeakerRoles[keyof typeof SpeakerRoles];
export type SpeakerRoleMap = Record<SpeakerRole, string>;

export function selectedTeacherToSpeakerRole(teacher: string | null): SpeakerRole | null {
    if (teacher === ChineseTeacher.Male) return SpeakerRoles.maleTeacher;
    if (teacher === ChineseTeacher.Female) return SpeakerRoles.femaleTeacher;
    if (teacher === ChineseTeacher.Female2) return SpeakerRoles.femaleTeacher2;
    return null;
}

export function conversationSpeakerNameToRole(speakerName: string | null | undefined): SpeakerRole | null {
    if (speakerName?.trim().toUpperCase() === 'A') return SpeakerRoles.speakerA;
    if (speakerName?.trim().toUpperCase() === 'B') return SpeakerRoles.speakerB;
    return null;
}

export const SpeakerApi = {
    getSpeakers: function () {
        return axiosInstance.request<SpeakerRoleMap>({
            method: 'GET',
            url: '/audio/speakers',
        });
    },
};
